import * as z from "zod/v4";

export const getGoogleMapsKey = {
  name: "getGoogleMapsKey" as const,
  input: z.object({}),
  output: z.object({ apiKey: z.string() }),
};
